import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import UserAcess from "../Layout/UserAccess";
import { useSelector } from "react-redux";
import { useAddUserAccessMutation } from "src/services/useraccess/UserAccessServices";
import { RootState } from "src/redux/store";
import { showToast } from "src/utils/showToaster";

const AddUserAccessWrapper = () => {
  const [apiStatus, setApiStatus] = useState(false);
  const [userRoleState, setUserRoleState] = React.useState<string>("");

  const navigate = useNavigate();
  const [addUserAccess] = useAddUserAccessMutation();

  const { checkUserAccess } = useSelector(
    (state: RootState) => state.userAccess
  );

  const handleUserAccessSubmit = () => {
    setApiStatus(true);
    setTimeout(() => {
      addUserAccess({
        userId: null,
        userRoleName: userRoleState
          ?.toUpperCase()
          ?.trim()
          ?.replaceAll(" ", "_"),
        module: [...checkUserAccess.modules],
      }).then((res:any) => {
        if ("data" in res) {
          if (res?.data?.status) {
            showToast("success", "User Access Added successfully!");
            navigate(`/admin/user-role`);
          } else {
            showToast("error", res?.data?.message);
          }
        } else {
          showToast("error", "Something went wrong");
        }
        setApiStatus(false);
      });
    }, 1000);
  };

  return (
      <UserAcess
        userRole={userRoleState as string}
        setUserRoleState={setUserRoleState}
        handleUserAccessSubmit={handleUserAccessSubmit}
        apiStatus={apiStatus}
        formType={"Add"}
      />
   
  );
};

export default AddUserAccessWrapper;
